import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { jsonGet } from '../api';
import { User } from '../models/user';

type SliceModel = User;
const sliceName: string = 'users';

const currRequests: Set<ModelId> = new Set;

export const fetchUser = createAsyncThunk(
    sliceName + '/fetchById',
    async (id: ModelId) => {
        if (currRequests.has(id)) {
            return null;
        } else {
            currRequests.add(id);
            return await jsonGet<SliceModel>('/data/' + sliceName + '/' + id);
        }
    }
);

export const userAdapter = createEntityAdapter<SliceModel>({
    selectId: (attrs: SliceModel) => attrs.id
});
export const userSlice = createSlice({
    name: sliceName,
    initialState: userAdapter.getInitialState(),
    reducers: {
        addMany: userAdapter.addMany,
        addOne: userAdapter.addOne,
        updateMany: userAdapter.updateMany,
        updateOne: userAdapter.updateOne,
        upsertOne: userAdapter.upsertOne,
        upsertMany: userAdapter.upsertMany,
        removeOne: userAdapter.removeOne
    },
    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
        builder.addCase(fetchUser.fulfilled, (state, action) => {
            if (action.payload) {
                currRequests.delete(action.payload.id);
                userAdapter.upsertOne(state, action.payload);
            }
        });
    },
});
